import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { FsService } from '../fs.service';

@Component({
    selector: 'blog-fs-add-section',
    templateUrl: './fs-add-section.component.html',
    styleUrls: ['./fs-add-section.component.scss'],
    imports: [CommonModule],
})
export class FsAddSectionComponent {
    @Input() public previewId?: string;
    @Input() public label?: string;

    public env = environment;

    public constructor(private fsSrvice: FsService) {}

    public addSectionClicked(): void {
        if (!this.previewId) {
            return;
        }
        this.fsSrvice.addSection(this.previewId);
    }
}
